import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-collapsing-shelf',
  templateUrl: './collapsing-shelf.component.html',
  styleUrls: ['./collapsing-shelf.component.scss'],
})
export class CollapsingShelfComponent implements OnInit {
  @Input() title = '';
  @Input() toggled = false;

  constructor() {}

  ngOnInit() {}

  toggle() {
    this.toggled = !this.toggled;
  }
}
